// src/components/common/FunPopup.js
//
// A cartoony popup in the middle of the screen — instead of the browser's
// plain "smartboardlearning.com says…" alert box.
//
//   const [pop, setPop] = useState(null);
//   setPop({ tone: "ok", title: "Saved!", text: "Your students see it now." });
//   <FunPopup pop={pop} onClose={() => setPop(null)} />
//
// tone: "ok" (green check, closes itself after a few seconds), "bad" (red),
// "info" (purple). A question: { …, onConfirm, yes: "Leave", no: "Stay" }.

import React, { useEffect } from "react";
import ModalPortal from "./ModalPortal";
import "./funPopup.css";

const ICONS = { ok: "✅", bad: "😕", info: "💡" };

const FunPopup = ({ pop, onClose, autoClose = 3200 }) => {
  useEffect(() => {
    if (!pop) return undefined;
    const onKey = (e) => (e.key === "Escape" || e.key === "Enter") && onClose?.();
    window.addEventListener("keydown", onKey);
    const t = pop.tone === "ok" && autoClose && !pop.onConfirm ? setTimeout(() => onClose?.(), autoClose) : null;
    return () => {
      window.removeEventListener("keydown", onKey);
      if (t) clearTimeout(t);
    };
  }, [pop, onClose, autoClose]);

  if (!pop) return null;
  const tone = pop.tone || "info";
  return (
    <ModalPortal>
      <div className="sbl-fun-pop" role="alertdialog" aria-modal="true" aria-label={pop.title} onMouseDown={(e) => e.target === e.currentTarget && onClose?.()}>
        <div className={`sbl-fun-card is-${tone}`}>
          <span className="sbl-fun-icon" aria-hidden="true">
            {pop.icon || ICONS[tone]}
          </span>
          {tone === "ok" && (
            <span className="sbl-fun-confetti" aria-hidden="true">
              {Array.from({ length: 14 }, (_, i) => (
                <i key={i} style={{ "--a": `${i * 26}deg`, "--d": `${(i % 4) * 40}ms` }} />
              ))}
            </span>
          )}
          <h2>{pop.title}</h2>
          {pop.text && <p>{pop.text}</p>}
          {pop.onConfirm ? (
            <div className="sbl-fun-two">
              <button
                type="button"
                className="is-yes"
                onClick={() => {
                  onClose?.();
                  pop.onConfirm();
                }}
              >
                {pop.yes || "Yes"}
              </button>
              <button type="button" className="is-no" onClick={onClose} autoFocus>
                {pop.no || "No"}
              </button>
            </div>
          ) : (
            <button type="button" onClick={onClose} autoFocus>
              {pop.button || (tone === "bad" ? "OK" : "Great!")}
            </button>
          )}
        </div>
      </div>
    </ModalPortal>
  );
};

export default FunPopup;
